// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import BlueButton from "../Components/BlueButton";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import { BRAND } from "../css/brand";
// import { fetchRoles } from "../Data/ROLES";
// import Select from "react-select";

// export default function UserForm({ onCancel, onSubmit }) {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     business_name: "",
//     mobile: "",
//     email: "",
//     district: "",
//     taluka: "",
//     pincode: "",
//     gst: "",
//     pan: "",
//     role: "",
//     owner_name: "",
//     company_id: "",
//     company_name: "",
//     state: "",
//     password: "",
//     cnf_id: "",
//     cnf_name: "",
//     dist_id: "",
//     ss_id: "",
//     ss_name: "",
//     dist_name: "",
//     fos_id: "",
//     fos_name: "",
//     promotor_name: "",
//     address: "",
//     logo: null,
//     document: null,
//     senior_id: "",
//     is_active: 1,
//   });

//   const [roles, setRoles] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [loginRole, setLoginRole] = useState(null);

//   // 🔹 New state/district logic
//   const stateOptions = [
//     "Maharashtra",
//     "Bihar",
//     "Uttar Pradesh",
//     "Uttarakhand",
//     "Haryana",
//   ];

//   const [districtOptions, setDistrictOptions] = useState([]);
//   const [loadingDistricts, setLoadingDistricts] = useState(false);

//   const fetchDistrictsByState = async (selectedState) => {
//     if (!selectedState) return;
//     try {
//       setLoadingDistricts(true);
//       const res = await axios.get(
//         `https://spillas.com/api/v1/org_user/statedistrict?state=${encodeURIComponent(selectedState
//         )}`
//       );
//       const data = res.data || [];
//       const districts = data.map((item) => item.district);
//       setDistrictOptions(districts);
//     } catch (err) {
//       console.error("Failed to fetch districts:", err);
//       setDistrictOptions([]);
//     } finally {
//       setLoadingDistricts(false);
//     }
//   };

//   // 🔹 Load session role and default associations
//   useEffect(() => {
//     const authUserString = sessionStorage.getItem("authUserData1");
//     if (!authUserString) return;

//     const authUser = JSON.parse(authUserString);
//     const loginUser = authUser?.data[0];
//     if (!loginUser) return;

//     const loginUserID = loginUser.id;
//     const loginUserName = loginUser.business_name;
//     const loginUserRole = Number(loginUser.role);

//     setLoginRole(loginUserRole);

//     const newForm = { ...form };

//     switch (loginUserRole) {
//       case 2:
//         newForm.company_id = loginUserID;
//         newForm.company_name = loginUserName;
//         newForm.senior_id = loginUserID;
//         break;

//       case 3:
//         newForm.company_id = loginUser.company_id || "";
//         newForm.company_name = loginUser.company_name || "";
//         newForm.cnf_id = loginUserID;
//         newForm.cnf_name = loginUserName;
//         break;

//       case 4:
//         newForm.company_id = loginUser.company_id || "";
//         newForm.company_name = loginUser.company_name || "";
//         newForm.cnf_id = loginUser.cnf_id || "";
//         newForm.cnf_name = loginUser.cnf_name || "";
//         newForm.ss_id = loginUserID;
//         newForm.ss_name = loginUserName;
//         break;

//       case 5:
//         newForm.company_id = loginUser.company_id || "";
//         newForm.company_name = loginUser.company_name || "";
//         newForm.cnf_id = loginUser.cnf_id || "";
//         newForm.cnf_name = loginUser.cnf_name || "";
//         newForm.ss_id = loginUser.ss_id || "";
//         newForm.ss_name = loginUser.ss_name || "";
//         newForm.dist_id = loginUserID;
//         newForm.dist_name = loginUserName;
//         break;

//       case 6:
//         newForm.company_id = loginUser.company_id || "";
//         newForm.company_name = loginUser.company_name || "";
//         newForm.cnf_id = loginUser.cnf_id || "";
//         newForm.cnf_name = loginUser.cnf_name || "";
//         newForm.ss_id = loginUser.ss_id || "";
//         newForm.ss_name = loginUser.ss_name || "";
//         newForm.dist_id = loginUser.dist_id || "";
//         newForm.dist_name = loginUser.dist_name || "";
//         newForm.fos_id = loginUserID;
//         newForm.fos_name = loginUserName;
//         break;

//       default:
//         break;
//     }

//     setForm((prev) => ({ ...prev, ...newForm }));
//   }, []);

//   // 🔹 Load roles dynamically
//   useEffect(() => {
//     async function loadRoles() {
//       const allRoles = await fetchRoles();
//       const roleOptions = Object.entries(allRoles)
//         .filter(([id]) => {
//           const numId = Number(id);
//           if (loginRole === 2) return [3, 4, 5, 7].includes(numId);
//           if (loginRole === 3) return [4, 5, 7].includes(numId);
//           if (loginRole === 4) return [5, 7].includes(numId);
//           if (loginRole === 5) return [6, 7].includes(numId);
//           if (loginRole === 6) return [7].includes(numId);
//           return false;
//         })
//         .map(([id, name]) => ({ value: Number(id), label: name }));
//       setRoles(roleOptions);
//     }

//     if (loginRole) loadRoles();
//   }, [loginRole]);

//   // 🔹 Handle Input Change
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) setForm((prev) => ({ ...prev, [name]: files[0] }));
//     else setForm((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   // 🔹 Validation
//   const validateForm = () => {
//     const newErrors = {};
//     if (!form.role) newErrors.role = "Selection of role is required.";
//     if (!form.business_name.trim())
//       newErrors.business_name = "Business name is required.";
//     if (!form.owner_name.trim()) newErrors.owner_name = "Owner name is required.";
//     if (!form.mobile.trim()) newErrors.mobile = "Mobile number is required.";
//     else if (!/^[6-9]\d{9}$/.test(form.mobile))
//       newErrors.mobile = "Enter a valid 10-digit mobile number.";
//     if (!form.email.trim()) newErrors.email = "Email is required.";
//     else if (!/\S+@\S+\.\S+/.test(form.email))
//       newErrors.email = "Enter a valid email address.";
//     if (!form.password.trim()) newErrors.password = "Password is required.";
//     else if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters.";
//     if (!form.pan.trim()) newErrors.pan = "PAN number is required.";
//     else if (!/[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(form.pan))
//       newErrors.pan = "Enter a valid PAN number.";
//     if (!form.taluka.trim()) newErrors.taluka = "Taluka is required.";
//     if (!form.state.trim()) newErrors.state = "State is required.";
//     if (!form.district.trim()) newErrors.district = "District is required.";
//     if (!form.pincode.trim()) newErrors.pincode = "Pincode is required.";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // 🔹 Submit Handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       const formData = new FormData();
//       Object.keys(form).forEach((key) => {
//         if (form[key] !== null && form[key] !== undefined)
//           formData.append(key, form[key]);
//       });

//       await axios.post("https://spillas.com/api/v1/org_user", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       Swal.fire({
//         title: "Success",
//         text: "Retailer saved successfully!",
//         icon: "success",
//         confirmButtonColor: "#2563eb",
//       }).then(() => navigate("/allretailers"));

//       onSubmit();
//     } catch (err) {
//       console.error("Error saving retailer:", err);
//       Swal.fire({
//         title: "Error",
//         text: "Something went wrong while saving retailer.",
//         icon: "error",
//         confirmButtonColor: "#dc2626",
//       });
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">

//         {/* Role */}
//         <div>
//           <select
//             name="role"
//             value={form.role}
//             onChange={handleChange}
//             className="w-full rounded-lg border px-3 py-2 text-sm"
//           >
//             <option value="">Select Role</option>
//             {roles.map((r) => (
//               <option key={r.value} value={r.value}>{r.label}</option>
//             ))}
//           </select>
//           {errors.role && <p className="text-red-500 text-xs">{errors.role}</p>}
//         </div>

//         {/* Business Name */}
//         <input
//           name="business_name"
//           value={form.business_name}
//           onChange={handleChange}
//           placeholder="Enter business name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* Owner Name */}
//         <input
//           name="owner_name"
//           value={form.owner_name}
//           onChange={handleChange}
//           placeholder="Enter owner name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* Mobile */}
//         <input
//           name="mobile"
//           value={form.mobile}
//           onChange={handleChange}
//           placeholder="Enter phone no."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* Email */}
//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Enter email"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* Password */}
//         <input
//           name="password"
//           type="password"
//           value={form.password}
//           onChange={handleChange}
//           placeholder="Enter password"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* GST */}
//         <input
//           name="gst"
//           value={form.gst}
//           onChange={handleChange}
//           placeholder="Enter GST No. (optional)"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* PAN */}
//         <input
//           name="pan"
//           value={form.pan}
//           onChange={handleChange}
//           placeholder="Enter PAN No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* Pincode */}
//         <input
//           name="pincode"
//           value={form.pincode}
//           onChange={handleChange}
//           placeholder="Enter Pin Code"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* Taluka */}
//         <input
//           name="taluka"
//           value={form.taluka}
//           onChange={handleChange}
//           placeholder="Enter Taluka"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* State */}
//         <select
//           name="state"
//           value={form.state}
//           onChange={(e) => {
//             const selectedState = e.target.value;
//             setForm((prev) => ({ ...prev, state: selectedState, district: "" }));
//             fetchDistrictsByState(selectedState);
//           }}
//           className="w-full rounded-lg border px-3 py-2 text-sm"
//         >
//           <option value="">Select State</option>
//           {stateOptions.map((s) => (
//             <option key={s} value={s}>
//               {s}
//             </option>
//           ))}
//         </select>

//         {/* District */}
//         <Select
//           name="district"
//           value={
//             form.district
//               ? { value: form.district, label: form.district }
//               : null
//           }
//           onChange={(selected) =>
//             handleChange({ target: { name: "district", value: selected?.value || "" } })
//           }
//           options={districtOptions.map((d) => ({ value: d, label: d }))}
//           placeholder={
//             loadingDistricts
//               ? "Loading districts..."
//               : form.state
//               ? "Select District"
//               : "Select State first"
//           }
//           isDisabled={!form.state || loadingDistricts}
//           isSearchable
//           styles={{
//             menuList: (base) => ({
//               ...base,
//               maxHeight: "160px", // Show around 5 options (scrollable)
//             }),
//             control: (base) => ({
//               ...base,
//               borderRadius: "0.5rem",
//               borderColor: "#d1d5db",
//               minHeight: "38px",
//               fontSize: "0.875rem",
//             }),
//           }}
//         />

//         {/* Document */}
//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Document (optional)</label>
//           <input
//             type="file"
//             name="document"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>

//         {/* Logo */}
//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Logo (optional)</label>
//           <input
//             type="file"
//             name="logo"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>
//       </div>

//       {/* Buttons */}
//       <div className="flex justify-end gap-2 mt-2">
//         <BlueButton brand={BRAND} type="button" onClick={onCancel}>
//           Cancel
//         </BlueButton>
//         <BlueButton brand={BRAND} type="submit">
//           Save User
//         </BlueButton>
//       </div>
//     </form>
//   );
// }



// ******************************** with auto fetch pincode***********************************************


import React, { useState, useEffect } from "react";
import axios from "axios";
import BlueButton from "../Components/BlueButton";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { BRAND } from "../css/brand";
import { fetchRoles } from "../Data/ROLES";

export default function UserForm({ onCancel, onSubmit }) {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    business_name: "",
    mobile: "",
    email: "",
    district: "",
    taluka: "",
    pincode: "",
    gst: "",
    pan: "",
    role: "", // role will come from select
    owner_name: "",
    company_id: "",
    company_name: "",
    state: "",
    password: "",
    cnf_id:"",
    cnf_name:"",
    dist_id: "",
    ss_id:"",
    ss_name:"",
    dist_name: "",
    fos_id:"",
    fos_name:"",
    promotor_name:"",
    address:"",
    logo: null,
    document: null,
    senior_id: "",
    is_active: 1,
  });

  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const [loadingPin, setLoadingPin] = useState(false);
  const [loginRole, setLoginRole] = useState(null);

  // Load session values
  // Load session values and set form based on role
    useEffect(() => {
    const authUserString = sessionStorage.getItem("authUserData1");
    if (!authUserString) return;

    const authUser = JSON.parse(authUserString);
    const loginUser = authUser?.data[0];
    if (!loginUser) return;

    const loginUserID = loginUser.id;
    const loginUserName = loginUser.business_name;
    const loginUserRole = Number(loginUser.role);

    setLoginRole(loginUserRole);

    const newForm = { ...form }; // start with default form state

    switch (loginUserRole) {
        case 2: // Company
        newForm.company_id = loginUserID;
        newForm.company_name = loginUserName;
        newForm.senior_id = loginUserID;
        break;

        case 3: // CNF
        newForm.company_id = loginUser.company_id || "";
        newForm.company_name = loginUser.company_name || "";
        newForm.cnf_id = loginUserID;
        newForm.cnf_name = loginUserName;
        break;

        case 4: // Super Stockist
        newForm.company_id = loginUser.company_id || "";
        newForm.company_name = loginUser.company_name || "";
        newForm.cnf_id = loginUser.cnf_id || "";
        newForm.cnf_name = loginUser.cnf_name || "";
        newForm.ss_id = loginUserID;
        newForm.ss_name = loginUserName;
        break;

        case 5: // Distributor
        newForm.company_id = loginUser.company_id || "";
        newForm.company_name = loginUser.company_name || "";
        newForm.cnf_id = loginUser.cnf_id || "";
        newForm.cnf_name = loginUser.cnf_name || "";
        newForm.ss_id = loginUser.ss_id || "";
        newForm.ss_name = loginUser.ss_name || "";
        newForm.dist_id = loginUserID;
        newForm.dist_name = loginUserName;
        break;

        case 6: // FOS
        newForm.company_id = loginUser.company_id || "";
        newForm.company_name = loginUser.company_name || "";
        newForm.cnf_id = loginUser.cnf_id || "";
        newForm.cnf_name = loginUser.cnf_name || "";
        newForm.ss_id = loginUser.ss_id || "";
        newForm.ss_name = loginUser.ss_name || "";
        newForm.dist_id = loginUser.dist_id || "";
        newForm.dist_name = loginUser.dist_name || "";
        newForm.fos_id = loginUserID;
        newForm.fos_name = loginUserName;
        break;

        default:
        break;
    }

    setForm((prev) => ({ ...prev, ...newForm }));
    }, []);

  // Load roles dynamically and filter based on session role
  useEffect(() => {
    async function loadRoles() {
      const allRoles = await fetchRoles(); // {id: name}
      const roleOptions = Object.entries(allRoles)
        .filter(([id]) => {
          const numId = Number(id);
          // role filter based on logged-in user's role
          if (loginRole === 2) return [3,4,5,7].includes(numId); // CNF sees SS, Dist, FOS, Retailer
          if (loginRole === 3) return [4,5,7].includes(numId);     // SS sees Dist, FOS, Retailer
          if (loginRole === 4) return [5,7].includes(numId);       // Dist sees FOS, Retailer
          if (loginRole === 5) return [6,7].includes(numId);       // FOS sees FOS, Retailer
          if (loginRole === 6) return [7].includes(numId);         // Retailer sees Retailer
          return false;
        })
        .map(([id, name]) => ({ value: Number(id), label: name }));
      setRoles(roleOptions);
    }

    if (loginRole) loadRoles();
  }, [loginRole]);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value, files } = e.target || {};
    if (files) setForm((prev) => ({ ...prev, [name]: files[0] }));
    else setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // Auto fetch state/district from pincode
    if (name === "pincode") {
      const pin = value.trim();
      if (pin.length === 6 && /^\d{6}$/.test(pin)) fetchStateAndDistrict(pin);
      else if (pin.length > 0 && pin.length !== 6) {
        setErrors((prev) => ({ ...prev, pincode: "Please enter a valid 6-digit pincode." }));
        setForm((prev) => ({ ...prev, state: "", district: "" }));
      }
    }
  };

  const fetchStateAndDistrict = async (pincode) => {
    try {
      setLoadingPin(true);
      const res = await axios.get(`https://goelectronix.in/public/api/v1/pincode/${pincode}`);
      if (res.data?.success) {
        const { state, district } = res.data;
        setForm((prev) => ({ ...prev, state: state || "", district: district || "" }));
        setErrors((prev) => ({ ...prev, pincode: "" }));
      } else {
        setErrors((prev) => ({ ...prev, pincode: "Please type correct pincode." }));
        setForm((prev) => ({ ...prev, state: "", district: "" }));
      }
    } catch (error) {
      console.error(error);
      setErrors((prev) => ({ ...prev, pincode: "Please type correct pincode." }));
      setForm((prev) => ({ ...prev, state: "", district: "" }));
    } finally {
      setLoadingPin(false);
    }
  };

  // 🔹 Validation logic
  const validateForm = () => {
    const newErrors = {};

    if (!form.role.trim())
      newErrors.role = "selection of role is required.";
    if (!form.business_name.trim())
      newErrors.business_name = "Business name is required.";
    if (!form.owner_name.trim()) newErrors.owner_name = "Owner name is required.";
    if (!form.mobile.trim()) newErrors.mobile = "Mobile number is required.";
    else if (!/^[6-9]\d{9}$/.test(form.mobile))
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    if (!form.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      newErrors.email = "Enter a valid email address.";
    if (!form.password.trim()) newErrors.password = "Password is required.";
    else if (form.password.length < 6)
      newErrors.password = "Password must be at least 6 characters.";
    if (!form.pan.trim()) newErrors.pan = "PAN number is required.";
    else if (!/[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(form.pan))
      newErrors.pan = "Enter a valid PAN number.";
    if (!form.taluka.trim()) newErrors.taluka = "Taluka is required.";
    if (!form.state.trim()) newErrors.state = "State is required.";
    if (!form.district.trim()) newErrors.district = "District is required.";
    if (!form.pincode.trim()) newErrors.pincode = "Pincode is required.";
    else if (!/^\d{6}$/.test(form.pincode))
      newErrors.pincode = "Enter a valid 6-digit pincode.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🔹 Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        if (form[key] !== null && form[key] !== undefined) {
          formData.append(key, form[key]);
        }
      });

      await axios.post("https://spillas.com/api/v1/org_user", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire({
        title: "Success",
        text: "Retailer saved successfully!",
        icon: "success",
        confirmButtonColor: "#2563eb",
      }).then(() => navigate("/allretailers"));

      onSubmit();
    } catch (err) {
      console.error("Error saving retailer:", err);
      Swal.fire({
        title: "Error",
        text: "Something went wrong while saving retailer.",
        icon: "error",
        confirmButtonColor: "#dc2626",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3 ">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">

        <div>
          {/* <label className="text-sm font-medium text-gray-700 mb-1 block">Select Role</label> */}
          <select
            name="role"
            value={form.role}
            onChange={handleChange}
            className="w-full rounded-lg border px-3 py-2 text-sm"
          >
            <option value="">Select Role</option>
            {roles.map((r) => (
              <option key={r.value} value={r.value}>{r.label}</option>
            ))}
          </select>
          {errors.role && <p className="text-red-500 text-xs">{errors.role}</p>}
        </div>
        {/* Business Name */}
        <div>
          <input
            name="business_name"
            value={form.business_name}
            onChange={handleChange}
            placeholder="Enter business name"
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {errors.business_name && (
            <p className="text-red-500 text-xs">{errors.business_name}</p>
          )}
        </div>

        {/* Owner Name */}
        <div>
          <input
            name="owner_name"
            value={form.owner_name}
            onChange={handleChange}
            placeholder="Enter owner name"
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {errors.owner_name && (
            <p className="text-red-500 text-xs">{errors.owner_name}</p>
          )}
        </div>

        {/* Mobile */}
        <div>
          <input
            name="mobile"
            value={form.mobile}
            onChange={handleChange}
            placeholder="Enter phone no."
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {errors.mobile && (
            <p className="text-red-500 text-xs">{errors.mobile}</p>
          )}
        </div>

        {/* Email */}
        <div>
          <input
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter email"
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
        </div>

        {/* Password */}
        <div>
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Enter password"
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {errors.password && (
            <p className="text-red-500 text-xs">{errors.password}</p>
          )}
        </div>

        {/* GST (optional) */}
        <input
          name="gst"
          value={form.gst}
          onChange={handleChange}
          placeholder="Enter GST No. (optional)"
          className="rounded-lg border px-3 py-2 text-sm w-full"
        />

        {/* PAN */}
        <div>
          <input
            name="pan"
            value={form.pan}
            onChange={handleChange}
            placeholder="Enter PAN No."
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {errors.pan && <p className="text-red-500 text-xs">{errors.pan}</p>}
        </div>

        {/* Pincode */}
        <div className="relative">
          <input
            name="pincode"
            value={form.pincode}
            onChange={handleChange}
            placeholder="Enter Pin Code"
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {loadingPin && (
            <span className="absolute right-3 top-2.5 text-xs text-gray-500">
              Loading...
            </span>
          )}
          {errors.pincode && (
            <p className="text-red-500 text-xs">{errors.pincode}</p>
          )}
        </div>

        {/* Taluka */}
        <div>
          <input
            name="taluka"
            value={form.taluka}
            onChange={handleChange}
            placeholder="Enter Taluka"
            className="rounded-lg border px-3 py-2 text-sm w-full"
          />
          {errors.taluka && (
            <p className="text-red-500 text-xs">{errors.taluka}</p>
          )}
        </div>

        {/* State */}
        <div>
          <input
            name="state"
            value={form.state}
            readOnly
            placeholder="Auto-filled State"
            className="rounded-lg border px-3 py-2 text-sm w-full bg-gray-100"
          />
          {errors.state && (
            <p className="text-red-500 text-xs">{errors.state}</p>
          )}
        </div>

        {/* District */}
        <div>
          <input
            name="district"
            value={form.district}
            readOnly
            placeholder="Auto-filled District"
            className="rounded-lg border px-3 py-2 text-sm w-full bg-gray-100"
          />
          {errors.district && (
            <p className="text-red-500 text-xs">{errors.district}</p>
          )}
        </div>

        {/* Document */}
        <div className="flex flex-col">
          <label className="text-xs mb-1">Document (optional)</label>
          <input
            type="file"
            name="document"
            onChange={handleChange}
            className="text-sm"
          />
        </div>

        {/* Logo */}
        <div className="flex flex-col">
          <label className="text-xs mb-1">Logo (optional)</label>
          <input
            type="file"
            name="logo"
            onChange={handleChange}
            className="text-sm"
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-2 mt-2">
        <BlueButton brand={BRAND} type="button" onClick={onCancel}>
          Cancel
        </BlueButton>
        <BlueButton brand={BRAND} type="submit">Save User</BlueButton>
      </div>
    </form>
  );
}


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import BlueButton from "./BlueButton";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";

// export default function RetailerForm({ onCancel, onSubmit }) {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     email: "",
//     password: "",
//     taluka: "",
//     pincode: "",
//     gst: "",
//     pan: "",
//     role: "5", // Default to Retailer
//     document: null,
//     logo: null,
//     state: "",
//     district: "",
//     is_active: 1,
//     company_id: "",
//     company_name: "",
//     dist_id: "",
//     dist_name: "",
//     senior_id: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [districts, setDistricts] = useState([]);

//   const districtOptions = districts.map((d) => ({
//     value: d.district,
//     label: d.district,
//   }));

//   // Load session values
//   useEffect(() => {
//     const authUserString = sessionStorage.getItem("authUserData1");
//     const authUser = JSON.parse(authUserString);
//     const loginUserID = authUser?.id;
//     const CompanyID = authUser?.company_id;
//     const CompanyName = authUser?.company_name;
//     const LoginUserName = authUser?.business_name;

//     setForm((prev) => ({
//       ...prev,
//       company_id: CompanyID || "",
//       company_name: CompanyName || "",
//       dist_id: loginUserID || "",
//       dist_name: LoginUserName || "",
//       senior_id: loginUserID || "",
//     }));
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setForm((prev) => ({ ...prev, [name]: files[0] }));
//     } else {
//       setForm((prev) => ({ ...prev, [name]: value }));
//     }
//     setErrors((prev) => ({ ...prev, [name]: "" })); // clear individual error
//   };

//   // Fetch districts
//   useEffect(() => {
//     const fetchDistricts = async () => {
//       if (!form.state) {
//         setDistricts([]);
//         setForm((prev) => ({ ...prev, district: "" }));
//         return;
//       }

//       try {
//         const res = await axios.get(
//           `https://spillas.comapi/v1/org_user/statedistrict?state=${form.state}`
//         );
//         setDistricts(res.data || []);
//         setForm((prev) => ({ ...prev, district: "" }));
//       } catch (err) {
//         console.error("Error fetching districts:", err);
//         setDistricts([]);
//       }
//     };
//     fetchDistricts();
//   }, [form.state]);

//   // 🔹 Validation logic
//   const validateForm = () => {
//     const newErrors = {};

//     if (!form.business_name.trim())
//       newErrors.business_name = "Business name is required.";
//     if (!form.owner_name.trim()) newErrors.owner_name = "Owner name is required.";
//     if (!form.mobile.trim()) newErrors.mobile = "Mobile number is required.";
//     else if (!/^[6-9]\d{9}$/.test(form.mobile))
//       newErrors.mobile = "Enter a valid 10-digit mobile number.";
//     if (!form.email.trim()) newErrors.email = "Email is required.";
//     else if (!/\S+@\S+\.\S+/.test(form.email))
//       newErrors.email = "Enter a valid email address.";
//     if (!form.password.trim()) newErrors.password = "Password is required.";
//     else if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters.";
//     if (!form.pan.trim()) newErrors.pan = "PAN number is required.";
//     else if (!/[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(form.pan))
//       newErrors.pan = "Enter a valid PAN number.";
//     if (!form.taluka.trim()) newErrors.taluka = "Taluka is required.";
//     if (!form.state.trim()) newErrors.state = "State is required.";
//     if (!form.district.trim()) newErrors.district = "District is required.";
//     if (!form.pincode.trim()) newErrors.pincode = "Pincode is required.";
//     else if (!/^\d{6}$/.test(form.pincode))
//       newErrors.pincode = "Enter a valid 6-digit pincode.";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // 🔹 Submit handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return; // stop if validation fails

//     try {
//       const formData = new FormData();
//       Object.keys(form).forEach((key) => {
//         if (form[key] !== null && form[key] !== undefined) {
//           formData.append(key, form[key]);
//         }
//       });

//       const res = await axios.post(
//         "https://spillas.comapi/v1/org_user",
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       Swal.fire({
//         title: "Success",
//         text: "Retailer saved successfully!",
//         icon: "success",
//         confirmButtonColor: "#2563eb",
//       }).then(() => navigate("/allretailers"));

//       onSubmit();
//     } catch (err) {
//       console.error("Error saving retailer:", err);

//       let errorHtml = "<ul style='text-align:center'>";
//       if (err.response?.data?.errors) {
//         Object.entries(err.response.data.errors).forEach(([field, msgs]) => {
//           msgs.forEach((msg) => (errorHtml += `<li><b>${field}</b>: ${msg}</li>`));
//         });
//         errorHtml += "</ul>";
//       } else {
//         errorHtml =
//           err.response?.data?.message ||
//           "Something went wrong while saving retailer.";
//       }

//       Swal.fire({
//         title: "Validation Error",
//         html: errorHtml,
//         icon: "error",
//         confirmButtonColor: "#dc2626",
//       });
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//         {/* Business Name */}
//         <div>
//           <input
//             name="business_name"
//             value={form.business_name}
//             onChange={handleChange}
//             placeholder="Enter business name"
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.business_name && (
//             <p className="text-red-500 text-xs">{errors.business_name}</p>
//           )}
//         </div>

//         {/* Owner Name */}
//         <div>
//           <input
//             name="owner_name"
//             value={form.owner_name}
//             onChange={handleChange}
//             placeholder="Enter owner name"
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.owner_name && (
//             <p className="text-red-500 text-xs">{errors.owner_name}</p>
//           )}
//         </div>

//         {/* Mobile */}
//         <div>
//           <input
//             name="mobile"
//             value={form.mobile}
//             onChange={handleChange}
//             placeholder="Enter phone no."
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.mobile && (
//             <p className="text-red-500 text-xs">{errors.mobile}</p>
//           )}
//         </div>

//         {/* Email */}
//         <div>
//           <input
//             name="email"
//             value={form.email}
//             onChange={handleChange}
//             placeholder="Enter email"
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
//         </div>

//         {/* Password */}
//         <div>
//           <input
//             name="password"
//             type="password"
//             value={form.password}
//             onChange={handleChange}
//             placeholder="Enter password"
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.password && (
//             <p className="text-red-500 text-xs">{errors.password}</p>
//           )}
//         </div>

//         {/* GST (optional) */}
//         <input
//           name="gst"
//           value={form.gst}
//           onChange={handleChange}
//           placeholder="Enter GST No. (optional)"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* PAN */}
//         <div>
//           <input
//             name="pan"
//             value={form.pan}
//             onChange={handleChange}
//             placeholder="Enter PAN No."
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.pan && <p className="text-red-500 text-xs">{errors.pan}</p>}
//         </div>

//         {/* Role (fixed to Retailer) */}
//         <select
//           name="role"
//           value={form.role}
//           disabled
//           className="rounded-lg border px-3 py-2 text-sm w-full bg-gray-100"
//         >
//           <option value="5">Retailer</option>
//         </select>

//         {/* Pincode */}
//         <div>
//           <input
//             name="pincode"
//             value={form.pincode}
//             onChange={handleChange}
//             placeholder="Enter Pin Code"
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.pincode && (
//             <p className="text-red-500 text-xs">{errors.pincode}</p>
//           )}
//         </div>

//         {/* Taluka */}
//         <div>
//           <input
//             name="taluka"
//             value={form.taluka}
//             onChange={handleChange}
//             placeholder="Enter Taluka"
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           />
//           {errors.taluka && (
//             <p className="text-red-500 text-xs">{errors.taluka}</p>
//           )}
//         </div>

//         {/* State */}
//         <div>
//           <select
//             name="state"
//             value={form.state}
//             onChange={handleChange}
//             className="rounded-lg border px-3 py-2 text-sm w-full"
//           >
//             <option value="">Select State</option>
//             <option value="Maharashtra">Maharashtra</option>
//             <option value="Bihar">Bihar</option>
//             <option value="Uttar Pradesh">Uttar Pradesh</option>
//             <option value="Uttarakhand">Uttarakhand</option>
//           </select>
//           {errors.state && (
//             <p className="text-red-500 text-xs">{errors.state}</p>
//           )}
//         </div>

//         {/* District */}
//         <div>
//           <Select
//             options={districtOptions}
//             placeholder="Select District"
//             value={districtOptions.find((o) => o.value === form.district) || null}
//             onChange={(selected) =>
//               handleChange({ target: { name: "district", value: selected.value } })
//             }
//             styles={{
//               menuList: (provided) => ({
//                 ...provided,
//                 maxHeight: 160,
//                 overflowY: "auto",
//               }),
//             }}
//           />
//           {errors.district && (
//             <p className="text-red-500 text-xs">{errors.district}</p>
//           )}
//         </div>

//         {/* Document (optional) */}
//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Document (optional)</label>
//           <input type="file" name="document" onChange={handleChange} className="text-sm" />
//         </div>

//         {/* Logo (optional) */}
//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Logo (optional)</label>
//           <input type="file" name="logo" onChange={handleChange} className="text-sm" />
//         </div>
//       </div>

//       <div className="flex justify-end gap-2 mt-2">
//         <BlueButton type="button" onClick={onCancel}>
//           Cancel
//         </BlueButton>
//         <BlueButton type="submit">Save Retailer</BlueButton>
//       </div>
//     </form>
//   );
// }



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import BlueButton from "./BlueButton";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";

// export default function RetailerForm({ onCancel, onSubmit }) {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     email: "",
//     password: "",
//     taluka: "",
//     pincode: "",
//     gst: "",
//     pan: "",
//     role: "",
//     document: null,
//     logo: null,
//     state: "",
//     district: "",
//     is_active: 1,
//     company_id: "",
//     company_name: "",
//     dist_id: "",
//     dist_name: "",
//     senior_id: "",
//   });

//   const [districts, setDistricts] = useState([]);

//   const districtOptions = districts.map((d) => ({
//     value: d.district,
//     label: d.district,
//   }));

//   // 🔹 Load session values on mount
//   useEffect(() => {
//     const authUserString = sessionStorage.getItem("authUserData1");
//     const authUser = JSON.parse(authUserString);
//     const loginUserID = authUser?.id;
//     const CompanyID = authUser?.company_id;
//     const CompanyName = authUser?.company_name;
//     const LoginUserName = authUser?.business_name;

//     setForm((prev) => ({
//       ...prev,
//       company_id: CompanyID || "",
//       company_name: CompanyName || "",
//       dist_id: loginUserID || "",
//       dist_name: LoginUserName || "",
//       senior_id: loginUserID || "",
//     }));
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setForm((prev) => ({ ...prev, [name]: files[0] }));
//     } else {
//       setForm((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // Fetch districts whenever state changes
//   useEffect(() => {
//     const fetchDistricts = async () => {
//       if (!form.state) {
//         setDistricts([]);
//         setForm((prev) => ({ ...prev, district: "" }));
//         return;
//       }

//       try {
//         const res = await axios.get(
//           `https://spillas.comapi/v1/org_user/statedistrict?state=${form.state}`
//         );
//         setDistricts(res.data || []);
//         // reset district if state changes
//         setForm((prev) => ({ ...prev, district: "" }));
//       } catch (err) {
//         console.error("Error fetching districts:", err);
//         setDistricts([]);
//       }
//     };

//     fetchDistricts();
//   }, [form.state]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
//       Object.keys(form).forEach((key) => {
//         if (form[key] !== null && form[key] !== undefined) {
//           formData.append(key, form[key]);
//         }
//       });

//       const res = await axios.post(
//         "https://spillas.comapi/v1/org_user",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       console.log("Retailer saved:", res.data);

//       Swal.fire({
//         title: "Success",
//         text: "Retailer saved successfully!",
//         icon: "success",
//         confirmButtonColor: "#2563eb",
//       }).then(() => {
//       navigate("/allretailers");   // ✅ redirect to all retailers
//     });

//       onSubmit();
//     } catch (err) {
//       console.error("Error saving retailer:", err);

//       let errorHtml = "<ul style='text-align:center'>";
//       if (err.response?.data?.errors) {
//         const errors = err.response.data.errors;
//         Object.entries(errors).forEach(([field, messages]) => {
//           messages.forEach((msg) => {
//             errorHtml += `<li><b>${field}</b>: ${msg}</li>`;
//           });
//         });
//         errorHtml += "</ul>";
//       } else {
//         errorHtml = err.response?.data?.message || "Something went wrong while saving retailer";
//       }

//       Swal.fire({
//         title: "Validation Error",
//         html: errorHtml,
//         icon: "error",
//         confirmButtonColor: "#dc2626",
//       });
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//         <input
//           name="business_name"
//           value={form.business_name}
//           onChange={handleChange}
//           placeholder="Enter business name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="owner_name"
//           value={form.owner_name}
//           onChange={handleChange}
//           placeholder="Enter owner name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="mobile"
//           value={form.mobile}
//           onChange={handleChange}
//           placeholder="Enter phone no."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />

//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Enter email"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="password"
//           type="password"
//           value={form.password}
//           onChange={handleChange}
//           placeholder="Enter password"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="gst"
//           value={form.gst}
//           onChange={handleChange}
//           placeholder="Enter GST No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <input
//           name="pan"
//           value={form.pan}
//           onChange={handleChange}
//           placeholder="Enter PAN No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <select
//           name="role"
//           value={form.role}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         >
//           <option value="">Select Role</option>
//           <option value="5">Retailer</option>
//         </select>

//         <input
//           name="taluka"
//           value={form.taluka}
//           onChange={handleChange}
//           placeholder="Enter Taluka"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* State Dropdown */}
//         <select
//           name="state"
//           value={form.state}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         >
//           <option value="">Select State</option>
//           <option value="Maharashtra">Maharashtra</option>
//           <option value="Bihar">Bihar</option>
//           <option value="Uttar Pradesh">Uttar Pradesh</option>
//           <option value="Uttarakhand">Uttarakhand</option>
//         </select>

//         {/* District Dropdown (Dynamic) */}
//         <Select
//           options={districtOptions}
//           placeholder="Select District"
//           value={districtOptions.find((o) => o.value === form.district) || null}
//           onChange={(selected) =>
//             handleChange({ target: { name: "district", value: selected.value } })
//           }
//           styles={{
//             menuList: (provided) => ({
//               ...provided,
//               maxHeight: 160, // controls scroll inside options
//               overflowY: "auto",
//             }),
//           }}
//         />

//         <input
//           name="pincode"
//           value={form.pincode}
//           onChange={handleChange}
//           placeholder="Enter Pin Code"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Document</label>
//           <input
//             type="file"
//             name="document"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Logo</label>
//           <input
//             type="file"
//             name="logo"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>
//       </div>

//       <div className="flex justify-end gap-2 mt-2">
//         <BlueButton type="button" onClick={onCancel}>
//           Cancel
//         </BlueButton>
//         <BlueButton type="submit">Save Retailer</BlueButton>
//       </div>
//     </form>
//   );
// }


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import BlueButton from "./BlueButton";
// import Select from "react-select";
// import Swal from "sweetalert2";

// export default function RetailerForm({ onCancel, onSubmit }) {
//   const [form, setForm] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     email: "",
//     password: "",
//     taluka: "",
//     pincode: "",
//     gst: "",
//     pan: "",
//     role: "",
//     document: null,
//     logo: null,
//     state: "",
//     district: "",
//     is_active: 1,
//     company_id: "",
//     company_name: "",
//     dist_id: "",
//     dist_name: "",
//     senior_id:"",
//   });

//   const [districts, setDistricts] = useState([]);

//   const districtOptions = districts.map((d) => ({
//   value: d.district,
//   label: d.district,
// }));

//   // 🔹 Load session values on mount
//   useEffect(() => {
//      const authUserString = sessionStorage.getItem("authUserData1");
//      const authUser = JSON.parse(authUserString);
//      const loginUserID = authUser?.id;
//      const CompanyID = authUser?.company_id;
//      const CompanyName = authUser?.company_name;
//      const LoginUserName = authUser?.business_name;
     

//     setForm((prev) => ({
//       ...prev,
//       company_id: CompanyID || "",
//       company_name: CompanyName || "",
//       dist_id: loginUserID || "",
//       dist_name: LoginUserName || "",
//       senior_id: loginUserID || "",
//     }));
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setForm((prev) => ({ ...prev, [name]: files[0] }));
//     } else {
//       setForm((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // Fetch districts whenever state changes
//   useEffect(() => {
//     const fetchDistricts = async () => {
//       if (!form.state) {
//         setDistricts([]);
//         setForm((prev) => ({ ...prev, district: "" }));
//         return;
//       }

//       try {
//         const res = await axios.get(
//           `https://spillas.comapi/v1/org_user/statedistrict?state=${form.state}`
//         );
//         setDistricts(res.data || []);
//         // reset district if state changes
//         setForm((prev) => ({ ...prev, district: "" }));
//       } catch (err) {
//         console.error("Error fetching districts:", err);
//         setDistricts([]);
//       }
//     };

//     fetchDistricts();
//   }, [form.state]);

//   const handleSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     const formData = new FormData();
//     Object.keys(form).forEach((key) => {
//       if (form[key] !== null && form[key] !== undefined) {
//         formData.append(key, form[key]);
//       }
//     });

//     const res = await axios.post(
//       "https://spillas.comapi/v1/org_user",
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );

//     console.log("Retailer saved:", res.data);

//     Swal.fire({
//       title: "Success",
//       text: "Retailer saved successfully!",
//       icon: "success",
//       confirmButtonColor: "#2563eb",
//     });

//     onSubmit();
//   } catch (err) {
//     console.error("Error saving retailer:", err);

//     // 🔹 Extract API error message if available
//     const errorMsg =
//       err.message ||
//       err.error ||
//       "Something went wrong while saving retailer";

//     Swal.fire({
//       title: "Error",
//       text: errorMsg,
//       icon: "error",
//       confirmButtonColor: "#dc2626",
//     });
//   }
// };


//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//         <input
//           name="business_name"
//           value={form.business_name}
//           onChange={handleChange}
//           placeholder="Enter business name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="owner_name"
//           value={form.owner_name}
//           onChange={handleChange}
//           placeholder="Enter owner name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="mobile"
//           value={form.mobile}
//           onChange={handleChange}
//           placeholder="Enter phone no."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />

//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Enter email"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="password"
//           type="password"
//           value={form.password}
//           onChange={handleChange}
//           placeholder="Enter password"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="gst"
//           value={form.gst}
//           onChange={handleChange}
//           placeholder="Enter GST No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <input
//           name="pan"
//           value={form.pan}
//           onChange={handleChange}
//           placeholder="Enter PAN No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <select
//           name="role"
//           value={form.role}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         >
//           <option value="">Select Role</option>
//           <option value="5">Retailer</option>
//         </select>

//         <input
//           name="taluka"
//           value={form.taluka}
//           onChange={handleChange}
//           placeholder="Enter Taluka"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* State Dropdown */}
//         <select
//           name="state"
//           value={form.state}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         >
//           <option value="">Select State</option>
//           <option value="Maharashtra">Maharashtra</option>
//           <option value="Bihar">Bihar</option>
//           <option value="Uttar Pradesh">Uttar Pradesh</option>
//           <option value="Uttarakhand">Uttarakhand</option>
//         </select>

//         {/* District Dropdown (Dynamic) */}
//         <Select
//           options={districtOptions}
//           placeholder="Select District"
//           value={districtOptions.find((o) => o.value === form.district) || null}
//           onChange={(selected) =>
//             handleChange({ target: { name: "district", value: selected.value } })
//           }
//           styles={{
//             menuList: (provided) => ({
//               ...provided,
//               maxHeight: 160, // controls scroll inside options
//               overflowY: "auto",
//             }),
//           }}
//         />



//         <input
//           name="pincode"
//           value={form.pincode}
//           onChange={handleChange}
//           placeholder="Enter Pin Code"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Document</label>
//           <input
//             type="file"
//             name="document"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Logo</label>
//           <input
//             type="file"
//             name="logo"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>
//       </div>

//       <div className="flex justify-end gap-2 mt-2">
//         <BlueButton type="button" onClick={onCancel}>
//           Cancel
//         </BlueButton>
//         <BlueButton type="submit">Save Retailer</BlueButton>
//       </div>
//     </form>
//   );
// }


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import BlueButton from "./BlueButton";

// export default function RetailerForm({ onCancel, onSubmit }) {
//   const [form, setForm] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     email: "",
//     password: "",
//     taluka: "",
//     pincode: "",
//     gst: "",
//     pan: "",
//     role: "",
//     document: null,
//     logo: null,
//     state: "",
//     district: "",
//     is_active: 1,
//     company_id: "",
//     company_name: "",
//     dist_id: "",
//     dist_name: "",
//   });

//   const [districts, setDistricts] = useState([]);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setForm((prev) => ({ ...prev, [name]: files[0] }));
//     } else {
//       setForm((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // Fetch districts whenever state changes
//   useEffect(() => {
//     const fetchDistricts = async () => {
//       if (!form.state) {
//         setDistricts([]);
//         setForm((prev) => ({ ...prev, district: "" }));
//         return;
//       }

//       try {
//         const res = await axios.get(
//           `https://spillas.com/api/v1/org_user/statedistrict?state=${form.state}`
//         );
//         setDistricts(res.data || []);
//         // reset district if state changes
//         setForm((prev) => ({ ...prev, district: "" }));
//       } catch (err) {
//         console.error("Error fetching districts:", err);
//         setDistricts([]);
//       }
//     };

//     fetchDistricts();
//   }, [form.state]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
//       Object.keys(form).forEach((key) => {
//         if (form[key] !== null && form[key] !== undefined) {
//           formData.append(key, form[key]);
//         }
//       });

//       const res = await axios.post(
//         "https://spillas.comapi/v1/org_user",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       console.log("Retailer saved:", res.data);
//       onSubmit();
//     } catch (err) {
//       console.error("Error saving retailer:", err);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//         <input
//           name="business_name"
//           value={form.business_name}
//           onChange={handleChange}
//           placeholder="Enter business name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="owner_name"
//           value={form.owner_name}
//           onChange={handleChange}
//           placeholder="Enter owner name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="mobile"
//           value={form.mobile}
//           onChange={handleChange}
//           placeholder="Enter phone no."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />

//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Enter email"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="password"
//           type="password"
//           value={form.password}
//           onChange={handleChange}
//           placeholder="Enter password"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="gst"
//           value={form.gst}
//           onChange={handleChange}
//           placeholder="Enter GST No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <input
//           name="pan"
//           value={form.pan}
//           onChange={handleChange}
//           placeholder="Enter PAN No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <select
//           name="role"
//           value={form.role}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         >
//           <option value="">Select Role</option>
//           <option value="retailer">Retailer</option>
//           <option value="distributor">Distributor</option>
//           <option value="cnf">CNF</option>
//         </select>

//         <input
//           name="taluka"
//           value={form.taluka}
//           onChange={handleChange}
//           placeholder="Enter Taluka"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         {/* State Dropdown */}
//         <select
//           name="state"
//           value={form.state}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         >
//           <option value="">Select State</option>
//           <option value="Maharashtra">Maharashtra</option>
//           <option value="Bihar">Bihar</option>
//           <option value="Uttar Pradesh">Uttar Pradesh</option>
//           <option value="Uttarakhand">Uttarakhand</option>
//         </select>

//         {/* District Dropdown (Dynamic) */}
//         <select
//           name="district"
//           value={form.district}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           disabled={!districts.length}
//         >
//           <option value="">Select District</option>
//           {districts.map((d) => (
//             <option key={d.id} value={d.district}>
//               {d.district}
//             </option>
//           ))}
//         </select>

//         <input
//           name="pincode"
//           value={form.pincode}
//           onChange={handleChange}
//           placeholder="Enter Pin Code"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Document</label>
//           <input
//             type="file"
//             name="document"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Logo</label>
//           <input
//             type="file"
//             name="logo"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>
//       </div>

//       <div className="flex justify-end gap-2 mt-2">
//         <BlueButton type="button" onClick={onCancel}>
//           Cancel
//         </BlueButton>
//         <BlueButton type="submit">Save Retailer</BlueButton>
//       </div>
//     </form>
//   );
// }


// import React, { useState } from "react";
// import axios from "axios";
// import BlueButton from "./BlueButton";

// export default function RetailerForm({ onCancel, onSubmit }) {
//   const [form, setForm] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     email: "",
//     password: "",
//     taluka: "",
//     pincode: "",
//     gst: "",
//     pan: "",
//     role: "",
//     document: null,
//     logo: null,
//     state: "",
//     district: "",
//     is_active: 1,
//     company_id: "",      // optional: fill if needed
//     company_name: "",    // optional
//     dist_id: "",         // optional
//     dist_name: "",       // optional
//   });

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setForm((prev) => ({ ...prev, [name]: files[0] }));
//     } else {
//       setForm((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
//       Object.keys(form).forEach((key) => {
//         if (form[key] !== null && form[key] !== undefined) {
//           formData.append(key, form[key]);
//         }
//       });

//       const res = await axios.post(
//         "https://spillas.comapi/v1/org_user",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       console.log("Retailer saved:", res.data);
//       onSubmit();
//     } catch (err) {
//       console.error("Error saving retailer:", err);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//         <input
//           name="business_name"
//           value={form.business_name}
//           onChange={handleChange}
//           placeholder="Enter business name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="owner_name"
//           value={form.owner_name}
//           onChange={handleChange}
//           placeholder="Enter owner name"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />
//         <input
//           name="mobile"
//           value={form.mobile}
//           onChange={handleChange}
//           placeholder="Enter phone no."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         />

//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Enter email"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="password"
//           type="password"
//           value={form.password}
//           onChange={handleChange}
//           placeholder="Enter password"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />
//         <input
//           name="gst"
//           value={form.gst}
//           onChange={handleChange}
//           placeholder="Enter GST No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <input
//           name="pan"
//           value={form.pan}
//           onChange={handleChange}
//           placeholder="Enter PAN No."
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <select
//           name="role"
//           value={form.role}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//           required
//         >
//           <option value="">Select Role</option>
//           <option value="retailer">Retailer</option>
//           <option value="distributor">Distributor</option>
//           <option value="cnf">CNF</option>
//         </select>

//         <input
//           name="taluka"
//           value={form.taluka}
//           onChange={handleChange}
//           placeholder="Enter Taluka"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <select
//           name="state"
//           value={form.state}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         >
//           <option value="">Select State</option>
//           <option value="Maharashtra">Maharashtra</option>
//           <option value="Gujarat">Gujarat</option>
//         </select>

//         <select
//           name="district"
//           value={form.district}
//           onChange={handleChange}
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         >
//           <option value="">Select District</option>
//           <option value="Pune">Pune</option>
//           <option value="Mumbai">Mumbai</option>
//         </select>

//         <input
//           name="pincode"
//           value={form.pincode}
//           onChange={handleChange}
//           placeholder="Enter Pin Code"
//           className="rounded-lg border px-3 py-2 text-sm w-full"
//         />

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Document</label>
//           <input
//             type="file"
//             name="document"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>

//         <div className="flex flex-col">
//           <label className="text-xs mb-1">Logo</label>
//           <input
//             type="file"
//             name="logo"
//             onChange={handleChange}
//             className="text-sm"
//           />
//         </div>
//       </div>

//       <div className="flex justify-end gap-2 mt-2">
//         <BlueButton type="button" onClick={onCancel}>
//           Cancel
//         </BlueButton>
//         <BlueButton type="submit">Save Retailer</BlueButton>
//       </div>
//     </form>
//   );
// }


// import { useState } from "react";
// import BlueButton from "./BlueButton";
// import RedButton from "./RedButton";

// export default function RetailerForm({ onCancel, onSubmit }) {
//   const [form, setForm] = useState({ name: "", owner: "", phone: "", email: "", address: "" });
//   return (
//     <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
//       <input
//         value={form.name}
//         onChange={(e) => setForm({ ...form, name: e.target.value })}
//         placeholder="Retailer Name"
//         className="rounded-lg border px-3 py-2 text-sm"
//       />
//       <input
//         value={form.owner}
//         onChange={(e) => setForm({ ...form, owner: e.target.value })}
//         placeholder="Owner Name"
//         className="rounded-lg border px-3 py-2 text-sm"
//       />
//       <input
//         value={form.phone}
//         onChange={(e) => setForm({ ...form, phone: e.target.value })}
//         placeholder="Phone"
//         className="rounded-lg border px-3 py-2 text-sm"
//       />
//       <input
//         value={form.email}
//         onChange={(e) => setForm({ ...form, email: e.target.value })}
//         placeholder="Email"
//         className="rounded-lg border px-3 py-2 text-sm"
//       />
//       <input
//         value={form.address}
//         onChange={(e) => setForm({ ...form, address: e.target.value })}
//         placeholder="Address"
//         className="sm:col-span-2 rounded-lg border px-3 py-2 text-sm"
//       />
//       <div className="sm:col-span-2 flex items-center justify-end gap-2">
//         <RedButton onClick={onCancel}>Cancel</RedButton>
//         <BlueButton onClick={() => onSubmit(form)}>Save Retailer</BlueButton>
//       </div>
//     </div>
//   );
// }